export default {
	compose: 'composed',
	service: 'servicios',
	variation: 'variantes',
};




// WEBPACK FOOTER //
// ./src/shared/enums/typeProduct.js